import React from 'react';
import ReactTooltip from 'react-tooltip';
interface ActiveInsightsFormatterProps {
  id: string;
  data: any;
}
const ActiveInsightsFormatter = ({
  id,
  data,
}: ActiveInsightsFormatterProps) => {
  const getRisk = (risk_status: string) => {
    switch (risk_status) {
      case 'h':
        return 'dotRed-active-insight';
      case 'm':
        return 'dotYellow-active-insight';
      case 'l':
        return 'dotGreen-active-insight';
      default:
        return 'dotYellow-active-insight';
    }
  };

  if (!data) return <></>;
  return (
    <div className="flexHorizCentered" key={id}>
      {data.highriskInsight && data.highriskInsight.risk_status === 'h' && (
        <div className={'offset-1 col-5'}>
          <button
            className={getRisk(data.highriskInsight.risk_status)}
            data-tip
            data-for={'mbsHeaderTip-' + id}
          >
            {data.highriskInsightNumber}
          </button>
          <ReactTooltip id={'mbsHeaderTip-' + id}>
            {data.whyCreated.map((whyCreated: string, index: number) => (
              <span key={`why-created-high-${index}`}>
                {whyCreated}
                <br />
              </span>
            ))}
          </ReactTooltip>
        </div>
      )}
      {!data.highriskInsight && <div className="cell-placeholder"></div>}
      {data.mediumriskInsight && data.mediumriskInsight.risk_status === 'm' && (
        <div className={'offset-1 col-5'}>
          <div
            className={`${getRisk(data.mediumriskInsight.risk_status)} , `}
            data-tip
            data-for={'pbsHeaderTip-' + id}
          >
            {data.mediumriskInsightNumber}
          </div>
          <ReactTooltip id={'pbsHeaderTip-' + id}>
            {data.whyCreated.map((whyCreated: string, index: number) => (
              <span key={`why-created-medium-${index}`}>
                {whyCreated}
                <br />
              </span>
            ))}
          </ReactTooltip>
        </div>
      )}
    </div>
  );
};

export default ActiveInsightsFormatter;
